<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children&&item.branch === branch">

      <template v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow">
        <!-- <el-badge :value="unreadNotifications" v-if="hasOneShowingChildren(item.children) && item.children[0].meta.badge === 'notification' && unreadNotifications !== 0" style="display: inline-block; width: 100%;"> -->
          <router-link :to="pathParser(item)"
            :key="item.children[0].name"
            v-if="hasOneShowingChildren(item.children) && item.children[0].meta.badge === 'notification' && unreadNotifications !== 0"
            style="overflow: visible;">
            <el-badge :value="unreadNotifications" class="notificationBadge">
              <el-menu-item :index="pathParser(item)" style="display: flex; justify-content: flex-start; align-items: center;" :class="{'submenu-title-noDropdown':!isNest}" :style="item.children[0].meta&&item.children[0].meta.title === 'Co. Settings' ? 'margin-top: 32px;' : ''">
                <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
                <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title" style="margin-left: 8px;">
                    {{item.children[0].meta.traceSidebar ? traceSidebar(item.children[0].meta.traceSidebar) : item.children[0].meta.title}}
                </span>
              </el-menu-item>
            </el-badge>
          </router-link>
        <!-- </el-badge> -->
        <router-link :to="pathParser(item)" v-else
          :key="item.children[0].name">
          <el-menu-item :index="pathParser(item)" style="display: flex; justify-content: flex-start; align-items: center;" :class="{'submenu-title-noDropdown':!isNest}" :style="item.children[0].meta&&item.children[0].meta.title === 'Co. Settings' ? 'margin-top: 32px;' : ''">
            <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
            <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title" style="margin-left: 8px;">
                {{item.children[0].meta.traceSidebar ? traceSidebar(item.children[0].meta.traceSidebar) : item.children[0].meta.title}}
            </span>
          </el-menu-item>
        </router-link>
      </template>

      <el-submenu v-else :index="item.name||item.path" :key="item.name"  :style="item.meta&&item.meta.title === 'Co. Settings' ? 'margin-top: 32px;' : ''">
        <template slot="title">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title" slot="title" style="margin-left: 4px; font-weight: bold;">{{item.meta.traceSidebar ? traceSidebar(item.meta.traceSidebar) : item.meta.title}}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>

          <router-link v-else :to="pathParser2(item, child)" :key="child.name">
            <el-menu-item :index="pathParser2(item, child)">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title" style="margin-left: 4px;">{{child.meta.traceSidebar ? traceSidebar(child.meta.traceSidebar) : child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
        <!-- <router-link :to="item.path+'/dataset'" :key="item.name+'_dataset'">
          <el-menu-item :index="item.path+'/dataset'">
            <el-button type="primary">+ Dataset</el-button>
          </el-menu-item>
        </router-link> -->
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    pathParser(item) {
      const path = item.path+'/'+item.children[0].path
      if (item.branch) {
        return path.replace(':branchId', this.$route.params.branchId)
      }
      return path
    },
    pathParser2(item, child) {
      const path = item.path+'/'+child.path
      if (item.branch) {
        return path.replace(':branchId', this.$route.params.branchId)
      }
      return path
    },
    traceSidebar(key) {
      console.log(key)
      switch (key) {
        case 'alpha': {
          return this.stepalphaprofile && this.stepalphaprofile.stepName ? this.stepalphaprofile.stepName : 'Step 1'
        }
        case 'bravo': {
          return this.stepbravoprofile && this.stepbravoprofile.stepName ? this.stepbravoprofile.stepName : 'Step 2'
        }
        case 'charlie': {
          return this.stepcharlieprofile && this.stepcharlieprofile.stepName ? this.stepcharlieprofile.stepName : 'Step 3'
        }
        case 'delta': {
          return this.stepdeltaprofile && this.stepdeltaprofile.stepName ? this.stepdeltaprofile.stepName : 'Step 4'
        }
        case 'echo': {
          return this.stepechoprofile && this.stepechoprofile.stepName ? this.stepechoprofile.stepName : 'Step 5'
        }
      }
    },
    kick(route) {
      this.$router.push(route)
    }
  },
  computed: {
    unreadNotifications() {
      return this.$store.getters.unreadNotifications
    },
    branch() {
      return this.$route.params.branchId !== undefined
    },
    stepalphaprofile() {
      return this.$store.state.trace.stepalphaprofile;
    },
    stepbravoprofile() {
      return this.$store.state.trace.stepbravoprofile;
    },
    stepcharlieprofile() {
      return this.$store.state.trace.stepcharlieprofile;
    },
    stepdeltaprofile() {
      return this.$store.state.trace.stepdeltaprofile;
    },
    stepechoprofile() {
      return this.$store.state.trace.stepechoprofile;
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .badge-item {
    margin-left: 5px;
  }
</style>
<style lang="scss">
.notificationBadge {
  width: 100%;
  .el-badge__content {
    right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/layout/components/Sidebar/SidebarItem.vue